import { Button } from '@/components/ui/button';
import { Menu, SquarePen } from 'lucide-react';

interface NavbarProps {
  onMenuClick: () => void;
  onNewChat?: () => void;
}

export const Navbar = ({ onMenuClick, onNewChat }: NavbarProps) => {
  return (
    <header className="flex h-16 shrink-0 items-center border-b bg-background px-4">
      <div className="flex size-12 items-center justify-start">
        <Button
          variant="ghost"
          size="icon"
          onClick={onMenuClick}
          aria-label="Open menu"
          className="focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <Menu className="h-6 w-6" />
        </Button>
      </div>
      <h1 className="flex-1 text-center text-lg font-bold leading-tight">
        Ask Compass
      </h1>
      <div className="flex size-12 items-center justify-end">
        <Button
          variant="ghost"
          size="icon"
          onClick={() => onNewChat?.()}
          aria-label="New chat"
          title="New chat"
          className="focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
        >
          <SquarePen className="h-5 w-5" />
        </Button>
      </div>
    </header>
  );
};
